import editEvent from 'app/shared/eventsOld/sagas/editEvent';
import retrieveActionEvents from 'app/shared/eventsOld/sagas/retrieveActionEvents';

const sagaRegistry = [editEvent, retrieveActionEvents];

export default sagaRegistry;
